import { Component, OnInit, ViewChild } from '@angular/core';
import {NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {ForgotPasswordComponent} from '../forgot-password/forgot-password.component';

import { AuthenticationService } from '../../user/_services/authentication.service';
import LogRocket from 'logrocket';
import { ADMIN_UTILITY, FORM_MSGS, PRODUCT_CONFIG } from 'src/app/_common/product-config';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';
import { CustomInputType } from 'src/app/_common/_enum/module.enum';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  errorMessage: string;
  warningMessage: string;
  successMessage: string;
  oldPSOPUrl: string;
  uid: string;
  loading = false;
  submitted = false;
  error = '';
  authenticationLoading = false;
  user: any = [];

  timeout = null;
  
  private customInputTypes = CustomInputType; // Using it in HTML
  private productConfig = PRODUCT_CONFIG; // Using it in HTML
  private adminMsgs = ADMIN_UTILITY; // Using it in HTML
  
  @ViewChild("somethingwentwrong", {static: false}) somethingWentWrong;
  @ViewChild("oldPSOPModal", {static: false}) oldPSOPModal;
  @ViewChild("sessionTimeoutModal", {static: false}) sessionTimeoutModal;

  constructor(config: NgbModalConfig, 
        private modalService : NgbModal,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router, 
        private authenticationService: AuthenticationService) {
    config.backdrop = 'static';
    config.keyboard = true;

    if (this.authenticationService.currentUser) { 
        this.router.navigate(['/']);
    }
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
        username: ['', Validators.required],
        password: ['', Validators.required]
    });
    // get resetPassword from route parameters - If found, open Reset Password Modal.
    this.uid = this.route.snapshot.queryParams['resetPassword'];

    if(this.uid != null && this.uid != ""){
      this.openResetPasswordModal();
    }

    if(history && history.state && history.state.warningMessage != undefined){
        this.warningMessage = history.state.warningMessage;
    }
    if(history && history.state && history.state.successMessage != undefined){
        this.successMessage = history.state.successMessage;
    }
  }

  onLogin(){
    this.resetAlertMessages();
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      this.errorMessage = FORM_MSGS.ValidUsernamePassword; // Enter a valid username and password to continue.
      return;
    }
    this.loading = true; 
    this.authenticationService.login(this.formControl.username.value, this.formControl.password.value).subscribe(data=>{
      this.loading = false;
      this.user = this.authenticationService.currentUser;
      this.authenticationService.factorChallenged = data.body.result.factorChallenged;
      if(this.user){
        if((this.user.factors || this.user.preferredFactor)){   
          this.authenticationService.authenticationScreen = true;
          //check for Okta sessionToken expiration
          this.timeout = setInterval(()=>{
            this.checkTimeout();
          }, 1000);
        }
        else if(this.user.mfaSkipped){
          this.authenticationService.authenticationScreen = true;
        }
        else{
          this.openSomethingWentWrongModal();
        }
      }
    },
    error => {
        this.error = error;
        this.loading = false;
        this.errorMessage = FORM_MSGS.ValidUsernamePassword; // Enter a valid username and password to continue.
    });
  }

  checkTimeout(){
    //once user is logged in and SID has been updated, stop checking for timeout
    if(!this.authenticationService.currentUser || (this.authenticationService.currentUser && this.authenticationService.currentUser.SID)){
      clearInterval(this.timeout);
    }else{ //get the current time and calculate expiration warning time
      let currentTime = new Date();
      let expiration = new Date(this.authenticationService.currentUser.tokenExpiration);
      let warning = new Date(expiration.getTime() - 60000);
      if(currentTime.toString() == warning.toString()){
        console.log("Session token will expire in 1 minute");
        LogRocket.log("Session token will expire in 1 minute");
        this.openSessionTimeoutModal();
      }else if(currentTime.toString() == expiration.toString()){
        console.log("Session token has expired");
        LogRocket.log("Session token has expired");
        clearInterval(this.timeout);
        this.ngOnDestroy();
        if(this.authenticationService.hasOpenModals()){ this.authenticationService.closeModal(); }
        this.clearStorage();
      }
    }
  }

  clearStorage(){
    this.authenticationService.removeData();
    this.authenticationService.authenticationScreen = false;
  }

  openSessionTimeoutModal(){
    let modalReference = this.modalService.open(this.sessionTimeoutModal, { centered: false, backdropClass: 'light-blue-backdrop' });
    modalReference.result.then((result) => {
    }, (reason) => {
    });
  }

  openSomethingWentWrongModal() {
   let modalReference = this.modalService.open(this.somethingWentWrong, { centered: true, backdropClass: 'light-blue-backdrop' });
    modalReference.result.then((result) => {
      this.resetAlertMessages();
    }, (reason) => {
    });
  }
  
  openForgotPasswordModal() {
   let modalReference = this.modalService.open(ForgotPasswordComponent, { centered: true, backdropClass: 'light-blue-backdrop' });
    modalReference.result.then((result) => {
      this.resetAlertMessages();
      if(!result.error){
        this.successMessage = FORM_MSGS.RequestToResetPasswordSent;
      }else{
        this.errorMessage = FORM_MSGS.SomethingWentWrong;
      }
    }, (reason) => {
    });
  }

  openResetPasswordModal() {
    let modalReference = this.modalService.open(ResetPasswordComponent, { centered: true, keyboard: false, backdropClass: 'light-blue-backdrop' });
 
    modalReference.componentInstance.uid = this.uid;
    
     modalReference.result.then((result) => {
      this.resetAlertMessages();
       this.successMessage = FORM_MSGS.PasswordHasBeenReset;
 
     }, (reason) => {
     });
  }
  get formControl() { 
    return this.loginForm.controls; 
  }

  resetAlertMessages(){
    this.errorMessage = "";
    this.successMessage = "";    
    this.warningMessage = "";
  }

  ngOnDestroy() {
    this.authenticationService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}